import quantityId from "../enums/quantityId.js";
import Unit from "./unit.js";

class Quantity{
    constructor(id, name) {
        if (!id){
            throw new TypeError('id cannot be empty');
        }

        if (Object.values(quantityId).indexOf(id) === -1){
            throw new TypeError('id must be defined in quantities enum');
        }

        this.id = id;
        this.name = name;
        this.units = {};
    }

    registerUnit(unit, override) {
        if (!(unit instanceof Unit)){
            throw new TypeError('unit must be instance of Unit class');
        }

        const shouldOverride = !!override;

        if (this.units.hasOwnProperty(unit.id) && !shouldOverride){
            throw new Error(`unit with id ${unit.id} cannot be re-defined`)
        }

        this.units[unit.id] = unit;
    }

    getUnit(unitId) {
        return this.units[unitId] || null;
    }
}

export default Quantity;